import BSWholeWheatNaanProduct from 'models/BSWholeWheatNaanProduct'

export const packagingInitialState = {
  category: BSWholeWheatNaanProduct.category,
  subCategory: BSWholeWheatNaanProduct.subCategory,
  Size: BSWholeWheatNaanProduct.Size,
}
